export const MULTIPLE_EVENTS_TAG_KEY = 'MultipleEvents'
export const EMPTY_EVENTS_TAG_KEY = 'EmptyEvents'
